import { type ReactNode } from 'react';
import styles from './Sidebar.module.css';

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  badge?: number;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

interface SidebarProps {
  groups: NavGroup[];
  activeId: string;
  onNavigate: (id: string) => void;
  userName?: string;
  userRole?: string;
  userEmail?: string;
  onLogout?: () => void;
  onProfileClick?: () => void;
}

const roleLabel: Record<string, string> = { super_admin: 'Super Admin', admin: 'Admin', viewer: 'Viewer', tenant_owner: '管理者', tenant_manager: 'マネージャー', tenant_staff: 'スタッフ' };

export function Sidebar({ groups, activeId, onNavigate, userName, userRole, userEmail, onLogout, onProfileClick }: SidebarProps) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.brandBlock}>
        <div className={styles.brandRow}>
          <div className={styles.brandIcon}>ME</div>
          <div>
            <div className={styles.brandName}>住縁 Mirai EMS</div>
            <div className={styles.brandSub}>estate.jiayin.jp</div>
          </div>
        </div>
        <div className={styles.consoleBadge}>SaaS Console</div>
      </div>

      <nav className={styles.nav}>
        {groups.map((group) => (
          <div key={group.label} className={styles.navGroup}>
            <div className={styles.navLabel}>{group.label}</div>
            {group.items.map((item) => (
              <div
                key={item.id}
                className={`${styles.navItem} ${activeId === item.id ? styles.active : ''}`}
                onClick={() => onNavigate(item.id)}
              >
                <span className={styles.navIcon}>{item.icon}</span>
                <span>{item.label}</span>
                {item.badge != null && item.badge > 0 && (
                  <span className={styles.navBadge}>{item.badge}</span>
                )}
              </div>
            ))}
          </div>
        ))}
      </nav>

      <div className={styles.sidebarFoot}>
        <div
          className={`${styles.adminRow} ${onProfileClick ? styles.adminRowClickable : ''}`}
          onClick={onProfileClick}
          title={onProfileClick ? 'プロフィール設定' : undefined}
        >
          <div className={styles.adminAv}>{(userName ?? 'SA').slice(0, 2)}</div>
          <div style={{ flex: 1 }}>
            <div className={styles.adminName}>{userName ?? '管理者'}</div>
            <div className={styles.adminRole}>{roleLabel[userRole ?? ''] ?? userRole ?? 'Admin'}</div>
            {userEmail && <div style={{ fontSize: '10px', fontFamily: 'var(--mono)', color: 'var(--ink3)', marginTop: 2 }}>{userEmail}</div>}
          </div>
          {onProfileClick && <span className={styles.profileIcon}>⚙️</span>}
        </div>
        {onLogout && (
          <button onClick={onLogout} className={styles.logoutBtn}>ログアウト</button>
        )}
      </div>
    </aside>
  );
}
